import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { ServicesPreview } from '@/components/sections/ServicesPreview';
import { ApproachDescription } from '@/components/sections/ApproachDescription';
import { SanctuarySection } from '@/components/sections/SanctuarySection';
import { Testimonials } from '@/components/sections/Testimonials';
import { resolveImagePath } from '@/utils/imageMap';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Home - Concierge Couples Counseling</title>
        <meta name="description" content="YOUR PARTNER IN NURTURING MEANINGFUL Relationships. Expert couples therapy focusing on fostering harmonious communication and creating a sanctuary of safety for healing relationships." />
        <meta name="keywords" content="couples counseling, relationship therapy, couples therapy, marriage counseling, relationship communication, therapeutic support, relationship healing" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.conciergecouplescounseling.com/" />
        
        {/* Open Graph tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Concierge Couples Counseling - Personalized Therapy for Stronger Bonds" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Home - Concierge Couples Counseling" />
        <meta property="og:description" content="YOUR PARTNER IN NURTURING MEANINGFUL Relationships. Expert couples therapy focusing on fostering harmonious communication and creating a sanctuary of safety for healing relationships." />
        <meta property="og:url" content="https://www.conciergecouplescounseling.com/" />
        <meta property="og:image" content={resolveImagePath('/images/logo.png')} />
        <meta property="og:image:secure_url" content={resolveImagePath('/images/logo.png')} />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Home - Concierge Couples Counseling" />
        <meta name="twitter:description" content="YOUR PARTNER IN NURTURING MEANINGFUL Relationships. Expert couples therapy focusing on fostering harmonious communication and creating a sanctuary of safety for healing relationships." />
        <meta name="twitter:image" content={resolveImagePath('/images/logo.png')} />
        
        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Concierge Couples Counseling",
            "description": "Personalized Therapy for Stronger Bonds",
            "url": "https://www.conciergecouplescounseling.com/",
            "logo": {
              "@type": "ImageObject",
              "url": resolveImagePath('/images/logo.png'),
              "width": 220,
              "height": 71
            },
            "image": resolveImagePath('/images/logo.png')
          })}
        </script>
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        <Hero />
        <ServicesPreview />
        <ApproachDescription />
        <SanctuarySection />
        <Testimonials />
        <Footer />
      </div>
    </>
  );
}